import React, { Component } from 'react';
import Button from '../button/Button';
export default class SecondaryButton extends Component {
	render() {
		return <Button color="blue" bg="white" {...this.props} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/secondaryButton/SecondaryButton.jsx